import { render, staticRenderFns } from "./BmControlEstatus.vue?vue&type=template&id=52661f2a&"
import script from "./BmControlEstatus.vue?vue&type=script&lang=js&"
export * from "./BmControlEstatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports